webpackJsonp([20],{

/***/ 562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(18);

var _reactStatic = __webpack_require__(12);

var _storyblokReact = __webpack_require__(31);

var _storyblokReact2 = _interopRequireDefault(_storyblokReact);

var _reactLazyload = __webpack_require__(70);

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

__webpack_require__(562);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Partners = function Partners(props) {
  var content = props.story.content;


  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        'title',
        null,
        content && content.top[0].title
      )
    ),
    content && content.top.map(function (el) {
      return _react2.default.createElement(
        'div',
        {
          key: el._uid,
          className: 'hero hero--small',
          style: {
            backgroundImage: 'url(' + el.image + ')',
            backgroundPosition: 'center ' + (el.image_offset ? el.image_offset + '%' : '50%')
          }
        },
        ' ',
        _react2.default.createElement('div', { className: 'hero__overlay' }),
        _react2.default.createElement(
          'div',
          { className: 'wrapper' },
          _react2.default.createElement(
            _storyblokReact2.default,
            { content: el },
            _react2.default.createElement(
              'h1',
              { className: 'hero__title hero--small__title' },
              el.title
            )
          )
        )
      );
    }),
    _react2.default.createElement(
      'div',
      { className: 'wrapper' },
      content.lead.map(function (el) {
        return _react2.default.createElement(
          _storyblokReact2.default,
          { key: el._uid, content: el },
          _react2.default.createElement(
            'div',
            { className: 'partners__intro paragraph--lead' },
            el.text
          )
        );
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'partner' },
        content.partners_list.map(function (el) {
          return _react2.default.createElement(
            _storyblokReact2.default,
            { key: el._uid, content: el },
            _react2.default.createElement(
              'div',
              { className: 'col-1-4' },
              _react2.default.createElement(
                'a',
                { href: el.link.url },
                _react2.default.createElement(
                  _reactLazyload2.default,
                  { height: '200' },
                  _react2.default.createElement('img', { className: 'partner__logo', src: el.logo, alt: '' })
                )
              )
            )
          );
        })
      )
    )
  );
};

exports.default = (0, _reactStatic.withRouteData)(Partners);

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Partners.8ee0e36c.js